import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { floorsSlice } from "../app/modules/Sitemap/_redux/floorsSlice";
import { devicesSlice } from "../app/modules/Device/_redux/devicesSlice";
import { accountsSlice } from "../app/modules/Account/_redux/accountsSlice";
import { manufacturersSlice } from "../app/modules/Manufacturer/_redux/manufacturersSlice";
import { thingChannelsSlice } from "../app/modules/Manufacturer/_redux/thingChannelsSlice";

export const rootReducer = combineReducers({
  // mains reducers
  auth: auth.reducer,
  devices: devicesSlice.reducer,
  floors: floorsSlice.reducer,
  accounts: accountsSlice.reducer,
  // configurations: floorsSlice.reducer, // Update reducer from configration 
  // automations: floorsSlice.reducer, // Update reducer from automation 
  manufacturers: manufacturersSlice.reducer, 
  // settings: floorsSlice.reducer, // Update reducer from settings
  // updates: floorsSlice.reducer, // Update reducer from updates
  // optionals reducers
  thingChannels: thingChannelsSlice.reducer,
  
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
